import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import LayoutRoutes from "./LayoutRoutes";
import PrivateRoutes from "./PrivateRoutes";
import SignIn from "../Auth";
import { useSelector } from "react-redux";
import { RootState } from "../ReduxToolkit/Store";
import { getFirstPermissionRoute } from "../Data/Layout/SidebarMenuList";

export default function Routers() {
  const { isAuthenticated, user } = useSelector((state: RootState) => state.auth);
  const defaultRoute = getFirstPermissionRoute(user?.permissions);

  return (
    <BrowserRouter basename={"/"}>
      <Routes>
        {isAuthenticated ? (
          <Route path="/" element={<Navigate to={defaultRoute} replace />} />
        ) : (
          <Route path="/login" element={<SignIn />} />
        )}
        <Route path="/" element={<PrivateRoutes />}>
          <Route path={`/*`} element={<LayoutRoutes />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
